import $ from 'jquery'
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});

export default {
    name: 'ligne-budgetaire',
    components: {
        ValidationProvider, ValidationObserver,
    },
    props: [],
    data() {
        return {
            tarif_filter: [
				{
                    libelle: 'Tous',
                    id: '0',
                },
                {
                    libelle: 'Dépense caisse',
                    id: '1',
                },
                {
                    libelle: 'Dépense Trésorerie',
                    id: '2',
                },
            ],
            filtre_tarif: '',

            is_loading_1: true,
            is_empty_1: false,

            is_loading_2: true,
            is_empty_2: false,
            save_loading: false,

            fields: [
                { key: 'libelle', label: 'Libellé' }, { key: 'action', label: 'Action.s' }
            ],

            tresor_fields: [
                { key: 'libelle', label: 'Libellé' }, { key: 'action', label: 'Action.s' }
            ],
            filter_1: "",
            filter_2: "",
            perPage: 10,
            currentPage: 1,
            lignes: [],

            modal_title: 'Nouvelle ligne',
            ligne_budget: {
                id: 0,
                libelle: '',
                source: [],
                source_id: 0
            },
            can_set_plafond: false,
            ligne_is_exist: false,
            is_edit: false,

            to_be_deleted: {
				ligne_id: 0,
                role_id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,
        }
    },
    computed: {
        liste_source_depense() {
            return this.$store.getters['liste_source_depense']
        },

        ligne_budgetaire_caisse() {
            return this.$store.getters['ligne_budgetaire_caisse']
        },

        c_rows() {
            return this.ligne_budgetaire_caisse.length;
        },

        ligne_budgetaire_tresorerie() {
            return this.$store.getters['ligne_budgetaire_tresorerie']
        },

        t_rows() {
            return this.ligne_budgetaire_tresorerie.length;
        },
    },
    mounted() {
        this.getLigneBudgetaires(4)
        this.getLigneBudgetaires(14)

        this.$store.dispatch('getListeSourceDepense')
    },
    methods: {
        onFilterTarif() {
			let id_selected = this.filtre_tarif.id

			if (id_selected > 0) {
				for(let i = 1; i <= 6; i++) {
					if (i != id_selected ) {
						$('.prestation-'+i).fadeOut(500)
					}
				}
				setTimeout(() => {
					$('.prestation-'+id_selected ).fadeIn(500)
				}, 500);
			} else {
				for(let i = 1; i <= 6; i++) {
					$('.prestation-'+i).fadeIn(500)
				}
			}
			
		},

        newLine() {
            this.modal_title = 'Nouvelle ligne'
            this.is_edit = false

            this.ligne_budget = {
                id: 0,
                libelle: '',
                source: [],
                source_id: 0
            }

            this.$refs.ligne_form.reset()
        },

        onSource() {
            // var c = document.getElementById(selector)
            // if (c.checked && c.value == 4) {
            //     $('.show-plafond').fadeIn(500)
            // } else if(!c.checked && c.value == 4) {
            //     $('.show-plafond').fadeOut(500)
            // }
        },

        clearError() {
            
        },

        async save() {
            const isValid = await this.$refs.ligne_form.validate();
            if (!isValid) {
                return;
            }
            this.save_loading = true

            const tmp_source = this.liste_source_depense.filter(item => item.libelle === 'Trésorerie');
            let source = tmp_source[0].id
            

            // var data = {
            //     id: this.ligne_budget.id,
            //     libelle: this.ligne_budget.libelle,
            //     dotation: this.ligne_budget.dotation,
            //     source: s,
            //     source_id: this.ligne_budget.source_id,
            //     plafond: this.ligne_budget.plafond
            // }

            var data = {
                id: this.ligne_budget.id,
                libelle: this.ligne_budget.libelle,
                source: source,
                source_id: this.ligne_budget.source_id
            }
            console.log(data);
            
            this.$store.dispatch('saveSourceDepense', data).then((response) => {
                if (response > 0) {
                    this.$refs.ligne_form.reset()
                    this.$refs.add_ligne.click()

                    this.getLigneBudgetaires(4)
                    this.getLigneBudgetaires(14)

                    this.successMsg("Ligne budgétaire ajoutée avec succès")
                } else {
                    this.ligne_is_exist = true
                }
                this.save_loading = false
            })

        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        getLigneBudgetaires(role_id) {
            if (role_id == 4) {
                this.is_loading_1 = true
            } else if (role_id == 14) {
                this.is_loading_2 = true
            }

            this.$store.dispatch('getLigneBudgetaire', role_id).then(() => {
                if (role_id == 4) {
                    if (this.ligne_budgetaire_caisse.length > 0) {
                        this.is_empty_1 = false
                    } else {
                        this.is_empty_1 = true
                    }
                } else if (role_id == 14) {
                    if (this.ligne_budgetaire_tresorerie.length > 0) {
                        this.is_empty_2 = false
                    } else {
                        this.is_empty_2 = true
                    }
                }

                if (role_id == 4) {
                    this.is_loading_1 = false
                } else if (role_id == 14) {
                    this.is_loading_2 = false
                }
            })
        },

        edit(data) {
            this.is_edit = true
            this.ligne_budget = {
                id: data.id,
                libelle: data.libelle,
                source: [],
                source_id: data.role_id
            }

            if (data.role_id == 4) {
                $('.show-plafond').fadeIn(500)
            } else {
                $('.show-plafond').fadeOut(500)
            }
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        /**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.to_be_deleted = {
                ligne_id: data.id,
                role_id: data.role_id,
                libelle: data.libelle
            }
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé 
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteLigneBudgetaire', this.to_be_deleted).then((response) => {
                    if (response > 0) {
                        this.successMsg('Ligne budgétaire supprimée avec succès')
                    }
                    this.del_loading = false;
                    this.is_confirm = false

					this.getLigneBudgetaires(this.to_be_deleted.role_id)
					this.$refs.del_ligne.click()
                })
            }
        },
    }
}


